import React, { useState } from "react";
import FormContent from "components/organisms/formContent/index.jsx";
import Button from "components/atoms/button/index.jsx";
import FormFieldset from "components/molecules/formFieldset/index.jsx";
import FormCol from "components/molecules/formCol/index.jsx";
import FormTextField from "components/molecules/formTextField/index.jsx";
import FormActions from "components/molecules/formActions/index.jsx";

const BringForm = ({ handleSubmit, brands, models, engines }) => {
  const [pristine, setPristine] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [data, setData] = useState({
    name: "",
    email: "",
    lastname: "",
    cellphone: "",
    brand_id: "",
    model_id: "",
    engine_id: "",
    license_plate: "",
    kms: "",
    year: "",
    model: "",
  });

  const handleChange = (e) => {
    setData({ ...data, [e.currentTarget.name]: e.currentTarget.value });
    setPristine(false);
  };

  const filteredModels = models.filter(
    (model) => model.id_brand === data.brand_id
  );

  const empty =
    !data.name ||
    !data.lastname ||
    !data.cellphone ||
    !data.year ||
    !data.brand_id ||
    !data.model_id ||
    !data.engine_id ||
    !data.kms ||
    !data.license_plate;

  return (
    <FormContent>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit(data);
        }}
      >
        <FormFieldset>
          <div className="FormInfo">
            <h3>¿Dónde puedo ver los usados de Buenos Aires? </h3>
            <p>
              Buscá usados en Buenos Aires en{" "}
              <a
                href="https://autos.mercadolibre.com.ar/capital-federal/#applied_filter_id%3Dstate%26applied_filter_name%3DUbicaci%C3%B3n%26applied_filter_order%3D4%26applied_value_id%3DTUxBUENBUGw3M2E1%26applied_value_name%3DCapital+Federal%26applied_value_order%3D6%26applied_value_results%3D24527%26is_custom%3Dfalse"
                target="_blank"
              >
                Mercado Libre
              </a>{" "}
              y copiá la URL del que te interese. Luego completa el siguiente
              formulario y nosotros lo vamos a buscar por vos.
            </p>
            <a
              href="https://autos.mercadolibre.com.ar/capital-federal/#applied_filter_id%3Dstate%26applied_filter_name%3DUbicaci%C3%B3n%26applied_filter_order%3D4%26applied_value_id%3DTUxBUENBUGw3M2E1%26applied_value_name%3DCapital+Federal%26applied_value_order%3D6%26applied_value_results%3D24527%26is_custom%3Dfalse"
              target="_blank"
            >
              <Button
                style="secondary"
                buttonText="Ver usados en Buenos Aires"
              />
            </a>
          </div>
        </FormFieldset>
        <FormFieldset>
          <h3>Tus datos </h3>

          <FormCol first="true">
            <FormTextField
              name="name"
              type="text"
              label="Nombre"
              onChange={handleChange}
              value={data.name}
            />

            <FormTextField
              name="email"
              type="email"
              label="Correo electrónico"
              onChange={handleChange}
            />
          </FormCol>

          <FormCol last="true">
            <FormTextField
              name="lastname"
              type="text"
              label="Apellido"
              onChange={handleChange}
              value={data.lastname}
            />

            <FormTextField
              name="cellphone"
              type="text"
              label="Celular"
              onChange={handleChange}
              value={data.cellphone}
            />
          </FormCol>

          <h3>Vehículo en el que estas interesado</h3>

          <FormTextField
            name="used_url"
            label="URL del vehículo que te interesa"
            type="text"
            placeholder="https://auto.mercadolibre.com.ar/MLA-1123196543..."
            onChange={handleChange}
            value={data.used_url}
          />

          <p>Copia y pega la URL del aviso del auto que te interese.</p>
        </FormFieldset>

        <FormActions>
          <Button
            disabled={pristine || submitting || empty}
            buttonText="Hacer pedido"
            type="submit"
          />
        </FormActions>
      </form>
    </FormContent>
  );
};

export default BringForm;
